var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "nav",
        {
          staticClass: "navbar",
          attrs: { role: "navigation", "aria-label": "main navigation" }
        },
        [
          _c(
            "div",
            { staticClass: "navbar-brand" },
            [
              _c(
                "router-link",
                { staticClass: "navbar-item", attrs: { to: "/" } },
                [
                  _c("p", { staticClass: "navbar-title" }, [
                    _vm._v("EUploader")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.isMobile
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !this.$store.state.isLoggedIn,
                          expression: "!this.$store.state.isLoggedIn"
                        }
                      ],
                      staticClass: "navbar-item"
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "button is-success",
                          attrs: { to: "/login" }
                        },
                        [_vm._v(_vm._s(_vm.$t("message.login")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  class: {
                    "navbar-burger burger": true,
                    "is-active": this.$store.state.ctoggleData
                  },
                  attrs: {
                    role: "button",
                    "aria-label": "menu",
                    "aria-expanded": "false",
                    "data-target": "navbarBasic"
                  },
                  on: { click: _vm.ctoggle }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }),
                  _vm._v(" "),
                  _c("span", { attrs: { "aria-hidden": "true" } }),
                  _vm._v(" "),
                  _c("span", { attrs: { "aria-hidden": "true" } })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                true: "navbarBasic",
                "navbar-menu": true,
                "is-active": this.$store.state.ctoggleData
              },
              attrs: { id: "navbarBasic" }
            },
            [
              _c(
                "div",
                { staticClass: "navbar-start" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: { to: "/contact" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.ctoggle($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("message.contact.title")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: { to: "/faq" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.ctoggle($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("message.faq.title")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: { to: "/subscription" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.ctoggle($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("message.subscription.title")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !this.$store.state.isLoggedIn,
                      expression: "!this.$store.state.isLoggedIn"
                    }
                  ],
                  staticClass: "navbar-end"
                },
                [
                  _c("div", { staticClass: "navbar-item" }, [
                    _c(
                      "div",
                      { staticClass: "buttons is-centered" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "button is-primary",
                            attrs: { to: "/signup" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.ctoggle($event)
                              }
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.signup")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c(
                              "router-link",
                              {
                                staticClass: "button is-success",
                                attrs: { to: "/login" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.ctoggle($event)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("message.login")))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.$store.state.isLoggedIn,
                      expression: "this.$store.state.isLoggedIn"
                    }
                  ],
                  staticClass: "navbar-end"
                },
                [
                  _c("div", { staticClass: "navbar-item" }, [
                    _c(
                      "div",
                      { staticClass: "buttons is-centered" },
                      [
                        !this.$store.state.isPremium
                          ? _c(
                              "router-link",
                              {
                                staticClass: "button is-primary",
                                attrs: { to: "/subscription" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.ctoggle($event)
                                  }
                                }
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.subscription.title"))
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "button is-primary",
                            attrs: { to: "/list" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.ctoggle($event)
                              }
                            }
                          },
                          [_c("p", [_vm._v(_vm._s(_vm.$t("message.list")))])]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "navbar-item has-dropdown is-hoverable" },
                    [
                      _c("a", { staticClass: "navbar-link" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(this.$store.state.email) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "navbar-dropdown" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "navbar-item",
                              attrs: { to: "/unsubscription" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.ctoggle($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.unsubscription")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "button is-success",
                              attrs: { to: "/logout" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.ctoggle($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.logout")))]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info is-center", class: this.$store.state.infoLevel },
        [
          _c("p", { staticClass: "has-text-weight-bold" }, [
            _vm._v(_vm._s(this.$store.state.infoMsg))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "info-date" }, [
            _vm._v(_vm._s(this.$store.state.infoDate))
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container cmain" },
      [
        !_vm.isMobile
          ? _c("adsense", {
              attrs: {
                "ad-client": "ca-pub-6042959271745689",
                "ad-slot": "7402635077",
                "ad-style": "display:block",
                "ad-format": "auto",
                "ad-full-width-responsive": "true"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile ? _c("br") : _vm._e(),
        _vm._v(" "),
        _c("router-view"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("adsense", {
          attrs: {
            "ad-client": "ca-pub-6042959271745689",
            "ad-slot": "6877921275",
            "ad-style": "display:block",
            "ad-format": "auto",
            "ad-full-width-responsive": "true"
          }
        }),
        _vm._v(" "),
        _c("h1", [_vm._v("直リンクできる無料の画像・ファイルアップローダー")])
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "container is-fluid" }, [
      _c("footer", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "content has-text-centered" },
          [
            _c("router-link", { attrs: { to: "/terms_of_service" } }, [
              _vm._v(_vm._s(_vm.$t("message.tos")))
            ]),
            _vm._v("\n        |\n        "),
            _c("router-link", { attrs: { to: "/asct" } }, [
              _vm._v(_vm._s(_vm.$t("message.asct")))
            ]),
            _vm._v(" "),
            _c("p", [
              _c("br"),
              _vm._v("Hosted\n          "),
              _c("strong", [_vm._v(_vm._s(this.$store.state.count))]),
              _vm._v(" files.\n        ")
            ]),
            _vm._v(" "),
            _c("social-sharing", {
              attrs: {
                url: "https://uploader.xzy.pw/",
                title:
                  "Easy Uploader - 直リンクできて無料でファイルをアップロードできるシンプルなファイル・画像アップローダー",
                description:
                  "簡単で直感的な直リンクできるファイル・画像アップローダーです。URLを知ってる人のみしかアクセスできないため、安心で安全です。自分から URL を教えない限り他人がファイルにアクセスすることはできません ファイルは直リンクで開けることができるため、SNS や 5ch を始めとした掲示板等で画像を直接表示させることが可能です。",
                quote:
                  "直リンクできて無料でファイルをアップロードできるシンプルなファイル・画像アップローダー"
              },
              inlineTemplate: {
                render: function() {
                  var _vm = this
                  var _h = _vm.$createElement
                  var _c = _vm._self._c || _h
                  return _c(
                    "div",
                    [
                      _c("network", { attrs: { network: "twitter" } }, [
                        _c("span", [
                          _c("img", {
                            attrs: {
                              src: "/static/images/twitter.svg",
                              width: "16",
                              alt: "アップローダー"
                            }
                          })
                        ]),
                        _vm._v(" Twitter\n            ")
                      ]),
                      _vm._v("|\n            "),
                      _c("network", { attrs: { network: "facebook" } }, [
                        _c("span", [
                          _c("img", {
                            attrs: {
                              src: "/static/images/facebook.svg",
                              width: "16",
                              alt: "アップローダー"
                            }
                          })
                        ]),
                        _vm._v(" Facebook\n            ")
                      ])
                    ],
                    1
                  )
                },
                staticRenderFns: []
              }
            }),
            _vm._v(" "),
            _vm._m(0)
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("\n          Icons made by "),
      _c(
        "a",
        { attrs: { href: "https://www.freepik.com/", title: "Freepik" } },
        [_vm._v("Freepik")]
      ),
      _vm._v(" from "),
      _c(
        "a",
        { attrs: { href: "https://www.flaticon.com/", title: "Flaticon" } },
        [_vm._v("www.flaticon.com")]
      ),
      _vm._v(" is licensed by "),
      _c(
        "a",
        {
          attrs: {
            href: "http://creativecommons.org/licenses/by/3.0/",
            title: "Creative Commons BY 3.0",
            target: "_blank"
          }
        },
        [_vm._v("CC 3.0\n          BY")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 